import { render, staticRenderFns } from "./all.vue?vue&type=template&id=5b5d4d80&scoped=true&"
import script from "./all.vue?vue&type=script&lang=js&"
export * from "./all.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("../../../assets/css/leftnavChat.css?vue&type=style&index=0&id=5b5d4d80&scoped=true&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "5b5d4d80",
  "7b6544c7"
  
)

export default component.exports